import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
    static values = {
        score: Number,
        color: String
    }

    connect() {
        const ctx = this.element.querySelector('canvas').getContext('2d')
        const score = this.scoreValue

        // Use passed color or determine based on score if not provided
        // Logic matches the previous SVG: > 50 is warning, else primary.
        // But let's make it smarter: > 75 error, > 50 warning, else primary/success

        let color = this.colorValue
        if (!color) {
            // Fallback colors if not passed
            if (score > 75) color = '#ef4444'      // Red
            else if (score > 50) color = '#eab308' // Yellow
            else color = '#4f46e5'                 // Indigo (Primary)
        }

        const data = {
            labels: ["Score", "Remaining"],
            datasets: [{
                data: [score, 100 - score],
                backgroundColor: [
                    color,
                    'rgba(0, 0, 0, 0.05)' // Light track
                ],
                borderWidth: 0,
                hoverBackgroundColor: [
                    color,
                    'rgba(0, 0, 0, 0.05)'
                ],
                cutout: '85%', // Thin line like the SVG
                borderRadius: 20
            }]
        }

        const config = {
            type: 'doughnut',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                    duration: 1500,
                    easing: 'easeOutQuart'
                }
            }
        }

        this.chart = new Chart(ctx, config)
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
        }
    }
}
